<template>
  <div id="home">
    <section class="hero is-primary is-bold">
      <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div class="navbar-brand">
              <router-link :to="{name: 'Home'}" class="navbar-item is-active">
                Crear
              </router-link>
              <a href="/random" class="navbar-item">
                Random
              </a>
            </div>
          </div>
        </nav>
      </div>

      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Pregunta nueva
          </h1>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="field">
          <label class="label" for="question">Pregunta</label>
          <div class="control">
            <input type="text" id="question" autofocus v-model="question"
              :class="['input', {'is-danger': validation && !validate.question}]">
          </div>
          <p v-show="validation && !validate.question" class="help is-danger">
            Valor requerido
          </p>
        </div>

        <div class="field">
          <label class="label" for="not">Botón de rechazo</label>
          <div class="control">
            <input type="text" id="not" value="No" maxlength="10" v-model="not"
              :class="['input', {'is-danger': validation && !validate.not}]">
          </div>
          <p v-show="validation && !validate.not" class="help is-danger">
            Valor requerido
          </p>
          <p class="help">Este texto aparecerá en el botón movible</p>
        </div>

        <div class="field">
          <label class="label" for="yes">Botón de aceptación</label>
          <div class="control">
            <input type="text" id="yes" value="Sí" maxlength="10" v-model="yes"
              :class="['input', {'is-danger': validation && !validate.yes}]">
          </div>
          <p v-show="validation && !validate.yes" class="help is-danger">
            Valor requerido
          </p>
        </div>

        <div class="field">
          <label class="label" for="confirm">Texto final</label>
          <div class="control">
            <textarea id="confirm" v-model="confirm"
              :class="['textarea', {'is-danger': validation && !validate.confirm}]"></textarea>
          </div>
          <p v-show="validation && !validate.confirm" class="help is-danger">
            Valor requerido
          </p>
        </div>

        <button :class="['button is-fullwidth is-primary', {'is-loading': loading}]"
          :disabled="loading" @click.prevent="create">
          Crear
        </button>
      </div>
    </section>
  </div>
</template>

<script>

import firebase from '../firebaseConfig';

export default {
  name: 'Home',
  data() {
    return {
      question: '',
      not: 'No',
      yes: 'Sí',
      confirm: '',
      validation: false,
      valid: true,
      validate: {
        question: true,
        not: true,
        yes: true,
        confirm: true,
      },
      loading: false,
    };
  },
  methods: {
    create() {
      this.checkForm();
      if (!this.valid) {
        return;
      }

      this.loading = true;
      const question = {
        question: this.question,
        not: this.not,
        yes: this.yes,
        confirm: this.confirm,
        date: Date.now(),
      };

      firebase
        .firestore()
        .collection('questions')
        .add(question)
        .then((document) => {
          this.$localStorage.set(document.id, JSON.stringify(question));

          this.$router.push({
            name: 'Question',
            params: {
              id: document.id,
            },
          });
        });
    },

    checkForm() {
      this.validate.question = Boolean(this.question.trim());
      this.validate.not = Boolean(this.not.trim());
      this.validate.yes = Boolean(this.yes.trim());
      this.validate.confirm = Boolean(this.confirm.trim());

      this.valid = Object.values(this.validate).reduce((t, n) => t && n);
      this.validation = true;
    },
  },

  watch: {
    question() {
      this.validate.question = Boolean(this.question.trim());
    },
    not() {
      this.validate.not = Boolean(this.not.trim());
    },
    yes() {
      this.validate.yes = Boolean(this.yes.trim());
    },
    confirm() {
      this.validate.confirm = Boolean(this.confirm.trim());
    },

  },
};
</script>
